"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InstructorReportCardController = /** @class */ (function () {
    function InstructorReportCardController(reportcard) {
        this.reportcard = reportcard;
    }
    return InstructorReportCardController;
}());
InstructorReportCardController.$inject = ["reportcard"];
exports.default = InstructorReportCardController;
